import React, { createContext, useContext } from 'react';

import { AbeetContextValue } from '@clutter/abeet';

interface IServerData {
  // LP Specific
  isHomepage?: boolean;

  // Shared
  tests: AbeetContextValue['tests'];
  gmbUrl?: string;
  yelpUrl?: string;
  device: 'desktop' | 'mobile';
  inferredZipCode?: string;
}

const ServerDataContext = createContext<IServerData>({
  tests: {},
  device: 'desktop',
});

export const ServerDataProvider: React.FC<{
  value: IServerData;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <ServerDataContext.Provider value={value}>
    {children}
  </ServerDataContext.Provider>
);

export const useServerDataContext = () => useContext(ServerDataContext);

export { ServerDataContext, IServerData };
